module.exports = {
  dimensions: {
    width: 80,
    height: 40
  },
  optical: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};